import _defineProperty from "C:/Users/onlyme/git_ssd/webs/generadoraleatorio.com/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toArray from "C:/Users/onlyme/git_ssd/webs/generadoraleatorio.com/gatsby/node_modules/@babel/runtime/helpers/esm/toArray";
import _slicedToArray from "C:/Users/onlyme/git_ssd/webs/generadoraleatorio.com/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { walkObject } from "@chakra-ui/utils";
import { calc } from "./calc";
import { cssVar } from "./css-var";
export function createThemeVars(target, options) {
  var context = {
    cssMap: {},
    cssVars: {}
  };
  walkObject(target, function (value, path) {
    var _tokenHandlerMap$firs; // firstKey will be e.g. "space"


    var _path = _slicedToArray(path, 1),
        firstKey = _path[0];

    var handler = (_tokenHandlerMap$firs = tokenHandlerMap[firstKey]) != null ? _tokenHandlerMap$firs : tokenHandlerMap.defaultHandler;

    var _handler = handler(path, value, options),
        cssVars = _handler.cssVars,
        cssMap = _handler.cssMap;

    Object.assign(context.cssVars, cssVars);
    Object.assign(context.cssMap, cssMap);
  });
  return context;
}
/**
 * Define transformation handlers for ThemeScale
 */

var tokenHandlerMap = {
  space: function space(keys, value, options) {
    var properties = tokenHandlerMap.defaultHandler(keys, value, options);

    var _keys = _toArray(keys),
        firstKey = _keys[0],
        referenceKeys = _keys.slice(1);

    var negativeLookupKey = firstKey + ".-" + referenceKeys.join(".");
    var negativeVarKey = keys.join("-");

    var _cssVar = cssVar(negativeVarKey, undefined, options.cssVarPrefix),
        variable = _cssVar.variable,
        reference = _cssVar.reference;

    var negativeValue = calc.negate(value);
    var varRef = calc.negate(reference);
    return {
      cssVars: properties.cssVars,
      cssMap: _extends({}, properties.cssMap, _defineProperty({}, negativeLookupKey, {
        value: "" + negativeValue,
        var: "" + variable,
        varRef: varRef
      }))
    };
  },
  defaultHandler: function defaultHandler(keys, value, options) {
    var lookupKey = keys.join(".");
    var varKey = keys.join("-");

    var _cssVar2 = cssVar(varKey, undefined, options.cssVarPrefix),
        variable = _cssVar2.variable,
        reference = _cssVar2.reference;

    return {
      cssVars: _defineProperty({}, variable, value),
      cssMap: _defineProperty({}, lookupKey, {
        value: value,
        var: variable,
        varRef: reference
      })
    };
  }
};